ACC.minicart = {

    $layer: $('.js-minicart-popup'),

    bindMiniCart: function () {
        var hover = false,
        minicartDelayTimeout,
        delay = 300;

        $('.js-minicart-link').on('mouseenter', function () {
            hover = true;
            if (ACC.minicart.$layer.data("needRefresh") != false) {
                ACC.minicart.$layer.data("needRefresh", false);

                minicartDelayTimeout = setTimeout(function () {
                    ACC.minicart.getMiniCartData(function () {
                        ACC.minicart.$layer.show();
                    });
                }, delay);
            } else {
                clearTimeout(minicartDelayTimeout);
            }

            minicartDelayTimeout = setTimeout(function () {
                ACC.minicart.$layer.clearQueue().show();
            }, delay);
        }
        ).on('mouseleave', function () {
            hover = false;
            clearTimeout(minicartDelayTimeout);

            setTimeout(function () {
                if (!hover) {
                    ACC.minicart.$layer.hide();
                }
            }, delay);
        });

        ACC.minicart.$layer.on('mouseenter', function () {
                hover = true;
            }
        ).on('mouseleave', function () {
                setTimeout(function () {
                    ACC.minicart.$layer.hide();
                    hover = false;
                }, 100);
            });
    },

    getMiniCartData: function (callback) {
        $.ajax({
            url: ACC.minicart.$layer.attr("data-rolloverPopupUrl"),
            cache: false,
            type: 'POST',
            success: function (result) {
                if (result != null && result.indexOf('js-minicart-popup-content') > 0) {
                    ACC.minicart.$layer.html(result);
                    callback();
                } else {
                    location.reload(true);
                }
            }
        });
    },

    refreshMiniCartCount: function (type, totalItems) {
    	if (!type) {
    		type = 'ORDER';
    	}

        $('.js-minicart-item-amount-' + type).html(totalItems);
        $('.js-minicart-item-amount-' + type).attr("data-article-amount", totalItems);
        ACC.minicart.$layer.data("needRefresh", true);
    }
};

$(document).ready(function () {
    ACC.minicart.bindMiniCart();

    // TODO: Fast workaround to show number of items in cart. Fix with KMVP-12918.
    $('.js-quote-mini-cart').append($('#hiddenQuoteRequestMinicartAmount').html());
});